import React, { useState, useRef, useEffect } from "react";

import {
    Container,
    Grid,
    TextField,
    Box,
    Button,
    IconButton,
    InputAdornment,
    Popover,
    Typography,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import InfoIcon from "@mui/icons-material/Info";
import { imagePath } from "../../../utils/assetUtils";
import { useTranslation } from "react-i18next";
import CONSTANTS from "../../../constants/constants";
import PasswordService from "../services/PasswordService";
import { Navigate, useLocation } from "react-router";
import { useNavigate } from "react-router-dom";
import { SnackbarAlert } from "../../common/SnackbarAlert";
import { snackbarActions } from "../../../redux/features/snackbar/snackbarSlice";
import SimpleReactValidator from "simple-react-validator";
import { ROUTES } from "../../../constants/routes";
import { useSearchParams } from "react-router-dom";
import DemoUserService from "../services/DemoUserService";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { commonActions } from "../../../redux/features/common/commonSlice";
import ProfileService from "../../Profile/services/ProfileService";
import { userActions } from "../../../redux/features/user/userSlice";
const CreatePassword = (props: any) => {
    const { showSnackbar, handleLoader, login } = props;

    const [searchParams] = useSearchParams();
    const invitationCode = searchParams.get("code");
    window.onpopstate = function (e: any) {
        if (window.location.href.includes(ROUTES.VERIFY_OTP)) {
            const responseMessage = t("forgotpassword.are_you_sure_want_to_exit");
            const response = confirm(responseMessage);
            if (!response) {
                e.stopPropagation();
                window.history.forward();
            } else {
                navigate(ROUTES.INITIAL_PAGE);
            }
        }
    };
    /* Language translate function*/
    const [t, i18n] = useTranslation();

    /* Language translate function*/
    const [passwordType, setPasswordType] = useState("password");
    const [confirmPasswordType, setConfirmPasswordType] = useState("password");
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
        null
    );
    const location = useLocation();
    const navigate = useNavigate();
    const email = location?.state?.email;
    // const forgotIsDemoUser = location?.state?.isDemoUser;
    const isDemoUser = useAppSelector((state) => state.common.demoUser);
    const forgotIsDemoUser = isDemoUser;
    const  alertMessage = "";
    const successAlert = false;
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState({
        passwordError: "",
        confirmPasswordError: "",
    });
    const [openSnackBar, setOpenSnackBar] = useState(false);

    // validation
    const [, forceUpdate] = useState(0);
    const passwordRestrictionWord = CONSTANTS.RESTRICTED_KEYWORD;
    const isMatchedPasswordRestrictionWord = (password: string) => {
        const isMatched = passwordRestrictionWord.find((item) => {
            if (password.toLowerCase().includes(item.toLowerCase())) {
                return true;
            }
        });
        if (isMatched) {
            return isMatched;
        }
        return false;
    };
    const dispatch = useAppDispatch();
    const validator = useRef(
        new SimpleReactValidator({
            autoForceUpdate: { forceUpdate },
            className: "text-danger",
            messages: {
                in: t("forgotpassword.password_does_not_match"),
                email: t("forgotpassword.please_enter_valid_password"),
                regex: t("forgotpassword.please_enter_valid_password"),
                required: t("required.this_field_cannot_be_empty"),
            },
            validators: {
                cainz: {
                    message: t("required.the_password_can_not_contain"),
                    rule: (val: string) => {
                        return !isMatchedPasswordRestrictionWord(val);
                    },
                },
            },
        })
    );

    useEffect(() => {
        forceUpdate(1);
    });

    const handleOnBlur = (e: any) => {
        const { name } = e.target;
        validator.current.showMessageFor(name);
    };


    useEffect(() => {
        !isDemoUser ? (!email ? navigate(ROUTES.INITIAL_PAGE) : null): "";
    });
    const handleChange = (e: any) => {
        const { name, value } = e.target;
        name === "password" ? setPassword(value) : setConfirmPassword(value);
        validator.current.hideMessageFor(name);
    };

    const getUserDetails = async () => {
        const isHitDummyURL = false;
        await new ProfileService({}, isHitDummyURL)
            .sellerInfo()
            .then((res) => {
                dispatch(userActions.USER_DETAILS(res));
            })
            .catch((err) => {
                showSnackbar(err?.message, false);
            });
    };

    const handleResetPassowrd = () => {
        if (validator.current.allValid()) {
            handleLoader(true);
            const payload = {
                newPassword: password,
                confirmPassword,
                email: email,
            };
            new PasswordService(payload)
                .reset(forgotIsDemoUser)
                .then((res) => {
                    handleLoader(false);
                    showSnackbar(res, true);
                    navigate(ROUTES.INITIAL_PAGE);
                })
                .catch((err) => {
                    handleLoader(false);
                    showSnackbar(err?.message, false);
                });
        } else {
            validator.current.showMessages();
        }
    };
    const handleDemoInvitation = () => {
        if (validator.current.allValid()) {
            handleLoader(true);
            const payload = {
                password: password,
                confirmPassword,
                invitationCode: invitationCode,
            };
            new PasswordService(payload)
                .demoUserSetPassword()
                .then(async (res) => {
                    console.log(res, "res ++++");
                    const { userEmail } = res;
                    handleLoader(false);
                    // showSnackbar(res?.isPasswordReseted, true);
                    const payload = { email: userEmail, password: confirmPassword };
                    const isHitDummyURL = false;
                    await new DemoUserService(payload, isHitDummyURL)
                        .demoUserlogin().then((res: any) => {
                            handleLoader(false);
                            const { name, email, userType, accessToken, isStoreCreated, storeId, storeName, storeCode, perPageLimit,demoUser } = res;
                            demoUser && dispatch(commonActions.DEMO_USER(true));
                            if (isStoreCreated === false && accessToken && userType != CONSTANTS.USER_TYPE_EXHIBITOR) {
                                login(accessToken, isStoreCreated, userType, email, name, perPageLimit, demoUser);
                                navigate(ROUTES.REGISTER_DETAILS);
                            } else {
                                setOpenSnackBar(true);
                                login(accessToken, true, userType, email, name, storeId, storeName, storeCode, perPageLimit);
                                if (userType != CONSTANTS.USER_TYPE_EXHIBITOR) {
                                    getUserDetails();
                                }
                                navigate(ROUTES.OMS);
                            }
                        }).catch((err:any) => {
                            handleLoader(false);
                            showSnackbar(err?.message, false);
                        });


                })
                .catch((err) => {
                    handleLoader(false);
                    showSnackbar(err?.message, false);
                });
        } else {
            validator.current.showMessages();
        }
    };



    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClickShowPassword = () => {
        passwordType=="password" ? setPasswordType("text") : setPasswordType("password");
    };

    const handleMouseDownPassword = () => {
        setPasswordType("text");
    };

    const handleClickShowConfirmPassword = () => {
        confirmPasswordType=="password" ? setConfirmPasswordType("text") : setConfirmPasswordType("password");
    };

    const handleMouseDownConfirmPassword = () => {
        setConfirmPasswordType("text");
    };

    const handleCloseSnackBar = () => {
        setOpenSnackBar(false);
    };

    const open = Boolean(anchorEl);

    const createPasswordAction = () => {
        if(isDemoUser && invitationCode){
            handleDemoInvitation();
        } else {
            handleResetPassowrd();
        }
    };

    return (
        <>
            {/* Login page starts here */}
            <Grid>
                <Container>
                    <Grid container spacing={4}>
                        {/* offset grid with column*/}
                        <Grid item xs={12} xl={4} lg={4} md={2} sm={12}></Grid>
                        {/* main grid column! */}
                        <Grid item xs={12} xl={4} lg={4} md={8} sm={12}>
                            <img className="logo-img" alt="cainz"src={imagePath("logo-large.png")}  />
                            <Box className="logo-content">
                                <Grid item xs={12} md={12}>
                                    <Grid sx={{ mb: 2 }}>
                                        <TextField
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                        // onTouchStart={handleMouseDownConfirmPassword}
                                                        // onTouchEnd={handleClickShowConfirmPassword}
                                                            onClick={handleClickShowPassword}
                                                        // onMouseDown={handleMouseDownConfirmPassword}
                                                        >
                                                            { passwordType=="password" ?
                                                                <VisibilityIcon /> :
                                                                <VisibilityOffIcon />
                                                            }
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                           
                                            type={passwordType}
                                            fullWidth
                                            name="password"
                                            value={password}
                                            label={t("forgotpassword.new_password")}
                                            variant="outlined"
                                            onChange={(e) => handleChange(e)}
                                            onBlur={(e) => handleOnBlur(e)}
                                        />
                                        {validator.current.message("password", password, [
                                            "required",
                                            CONSTANTS.RESTRICTED_KEYWORD.toString(),
                                            { regex: CONSTANTS.PASSWORD_REGEX },
                                        ])}
                                    </Grid>

                                    <Grid sx={{ mb:1}}>
                                        <TextField
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                        // onTouchStart={handleMouseDownConfirmPassword}
                                                        // onTouchEnd={handleClickShowConfirmPassword}
                                                            onClick={handleClickShowConfirmPassword}
                                                        // onMouseDown={handleMouseDownConfirmPassword}
                                                        >
                                                            { confirmPasswordType=="password" ?
                                                                <VisibilityIcon /> :
                                                                <VisibilityOffIcon />
                                                            }
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                            type={confirmPasswordType}
                                            fullWidth
                                            name="confirmPassword"
                                            value={confirmPassword}
                                            label={t("forgotpassword.confirm_password")}
                                            variant="outlined"
                                            onChange={(e) => handleChange(e)}
                                            onBlur={(e) => handleOnBlur(e)}
                                        />
                                        {validator.current.message(
                                            "confirmPassword",
                                            confirmPassword,
                                            [
                                                "required",
                                                CONSTANTS.RESTRICTED_KEYWORD.toString(),
                                                { in: password },
                                                { regex: CONSTANTS.PASSWORD_REGEX },
                                            ]
                                        )}
                                    </Grid>

                                    <Typography sx={{width: "auto", color:"#201d1d94"}}>
                                        {t("updatepassword.password_suggestion")}
                                    </Typography>

                                    <Grid sx={{ my: 2 }}>
                                        <Button fullWidth onClick={createPasswordAction}>
                                            {isDemoUser ? t("register_seller.register") : t("updatepassword.submit")}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                        {/* offset grid with column*/}
                        <Grid item xs={12} xl={4} lg={4} md={2} sm={12}></Grid>
                    </Grid>
                    <SnackbarAlert
                        openSnackBar={openSnackBar}
                        message={alertMessage}
                        success={successAlert}
                        handleCloseSnackBar={handleCloseSnackBar}
                    />
                </Container>
            </Grid>
            {/* Login page ends here */}
        </>
    );
};

export default CreatePassword;
